import React from 'react';

const AdminWarehouseCreate: React.FC = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-3">创建仓库</h1>
      <div className="text-gray-500">此页面为占位页，后续将接入表单与提交逻辑。</div>
    </div>
  );
};

export default AdminWarehouseCreate;


